import { WarningIcon } from "components/SvgIcons"
import { Box, Text, Spacer } from "@chakra-ui/react"
import React from "react"
import { colours } from "@shared/ui.design-system"
import { space } from "theme/themeConfig"
import { Wrapper } from "./NotificationsBanner.styles"

export const NotificationFallback: React.FC = () => (
  <Wrapper
    data-testid="notification-banner"
    backgroundColor={colours.error.medium}
    borderLeft={`4px solid ${colours.error.light}`}
  >
    <Box>
      <WarningIcon
        boxSize="2rem"
        color={colours.primary.dark}
        mx={1}
        data-testid="warning-icon"
      />
    </Box>
    <Box justifyContent="left" letterSpacing="0.02em">
      <Text variant="acuminSemiBold" wordBreak="break-word" mt={0}>
        Oops, something went wrong.
      </Text>
      <Text
        variant="acuminRegular"
        wordBreak="break-word"
        mt={space["-5"]}
        letterSpacing="0.02"
      >
        <Text as="span">
          If the error persists, please contact member happiness for further
          assistance.
        </Text>
      </Text>
    </Box>
    <Spacer />
  </Wrapper>
)
